import { createContext } from "react";

const WebSocketClient = createContext(null);
const WebSocketStatus = createContext(false);

export {
    WebSocketClient,
    WebSocketStatus
}